export default __webpack_public_path__ + "static/media/home.4160ef55.svg";